export const welcomeModal = () => {
    return {
        storageKey: 'welcomeModalClosed',

        init() {
            this.$refs.modal.addEventListener('hidden.bs.modal', () => this.close());
            const welcomeModal = new bootstrap.Modal('#welcomeModal')
            if (sessionStorage.getItem(this.storageKey) !== 'true') welcomeModal.show();
        },
        close() {
            sessionStorage.setItem(this.storageKey, 'true');
        }
    }
}